import {ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
import {appContextReducer, initialAppContextState} from './app-context.reducers';
import {initialTransactionState, transactionReducers} from './transaction.reducers';
import {AppState} from '../../interfaces/app-state.interface';
import {environment} from 'src/environments/environment';
import {initialZahlungState, zahlungReducer} from './zahlung.reducers';
import {initialZahlungenTableState, zahlungenTableReducer} from './zahlungen-table.reducers';
import {belegFilterTableReducer, initialBelegFilterTableState} from './beleg-filter-table.reducers';
import {belegReducers, initialBelegState} from './beleg.reducers';
import {initialZahlungsprotokollState, zahlungsprotokollReducer} from './zahlungsprotokoll.reducers';
import {initialJfLibState, jfLibReducers} from '@adnova/jf-ng-components';


export const initialAppState: AppState = {
  ...initialJfLibState,
  appContextReducer: initialAppContextState,
  zahlungReducer: initialZahlungState,
  zahlungenTableReducer: initialZahlungenTableState,
  belegFilterTableReducer: initialBelegFilterTableState,
  belegReducer: initialBelegState,
  transactionReducer: initialTransactionState,
  zahlungsprotokollReducer: initialZahlungsprotokollState,
};

export const reducers: ActionReducerMap<AppState> = {
  ...jfLibReducers,
  appContextReducer: appContextReducer,
  zahlungReducer: zahlungReducer,
  zahlungenTableReducer: zahlungenTableReducer,
  belegFilterTableReducer: belegFilterTableReducer,
  belegReducer: belegReducers,
  transactionReducer: transactionReducers,
  zahlungsprotokollReducer: zahlungsprotokollReducer,
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
